import type { Config, DOMPurify as DOMPurifyI } from 'dompurify';
import * as DOMPurifyNamespace from 'dompurify';

// Handle namespace import of default export (dev server wraps in .default, testserver and other bundlers may flatten)
const DOMPurifyNamespaceTyped = DOMPurifyNamespace as { default: DOMPurifyI } | DOMPurifyI;
const DOMPurify: DOMPurifyI =
  (DOMPurifyNamespaceTyped as { default: DOMPurifyI }).default ?? (DOMPurifyNamespaceTyped as DOMPurifyI);

export function sanitizeHtmlWithConfig(possibleUnsafeHtml: string, config: Config): string {
  return DOMPurify.sanitize(possibleUnsafeHtml, config);
}
